<template>
  <article
    class="schedule__card card"
    :style="{ top: `${top}px`, height: `${itemHeight}px` }"
    data-lazyanimation="fade"
  >
    <div
      class="card__container"
      :style="{ height: `${itemHeight - 35}px` }"
    >
      <div class="card__header" v-if="data.hashtags !== ''">
        {{ data.hashtags }}
      </div>

      <div class="card__content">
        <span class="card__spacer" />
        <h4 class="card__title">{{ data.title }}</h4>

        <div
          class="card__description"
          v-html="data.description"
          v-if="data.description.length > 7"
        >
          {{ data.description }}
        </div>
      </div>
    </div>
  </article>
</template>

<script>
import { isMobile } from '@/scripts/utils';

export default {
  name: 'TimetableItem',

  props: {
    data: {
      type: Object,
      required: true,
    },

    starts: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      deltaH: 0,
      top: 0,
      itemHeight: 0,

      isMobile,
    };
  },

  mounted() {
    this.calcVars();
    this.calcItemHeight();
  },

  methods: {
    calcVars() {
      const halfHourPx = 260;

      this.deltaH = halfHourPx / 30;
      this.top = this.starts.indexOf(this.data.start) * (halfHourPx / 6);
    },

    calcItemHeight() {
      const time1 = this.data.end.split(':');
      const time2 = this.data.start.split(':');
      const duration = ((parseInt(time1[0], 10) * 60) + parseInt(time1[1], 10))
        - ((parseInt(time2[0], 10) * 60) + parseInt(time2[1], 10));

      this.itemHeight = duration * this.deltaH;
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  display: block;
  padding: 15px 0 20px;
  width: calc(100% - 60px);

  @include mq(mobileL) {
    width: calc(100% - 140px);
  }

  @include mq(ipadL) {
    width: $unit-vw * 16;
  }

  &__container {
    position: relative;

    color: var(--color-headline-dark);
    transition: transform 0.35s $outCirc;

    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-flow: column nowrap;

    @at-root [data-city="toronto"] & {
      color: var(--color-cursor);
    }

    &::before,
    &::after {
      content: '';

      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;

      background-color: $color-white;
    }

    &::before {
      top: 5px;
      left: 5px;

      background-color: var(--color-headline-dark);
      transition: transform 0.35s $outCirc;
      z-index: -2;

      @at-root [data-city="toronto"] & {
        background-color: var(--color-cursor);
      }
    }

    &::after {
      z-index: -1;
    }
  }

  &__header {
    display: block;
    position: relative;
    width: calc(100% - #{2 * $unit-vw});
    padding: 12px 0;
    margin-left: 2 * $unit-vw;

    color: var(--color-headline-dark);

    @at-root [data-city="toronto"] & {
      color: var(--color-cursor);
    }

    @include mq(ipadP) {
      width: calc(100% - #{$unit-vw});
      margin-left: $unit-vw;
      padding: 15px 0;
    }

    &::before {
      content: '';

      position: absolute;
      bottom: 0;
      right: 0;
      width: 100%;
      height: 1px;

      background-color: var(--color-headline-dark);

      @at-root [data-city="toronto"] & {
        background-color: var(--color-cursor);
      }
    }
  }

  &__content {
    flex: 1 1 auto;
    width: 100%;
    padding: 12px 20px 12px $unit-vw * 2;

    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-flow: column nowrap;

    @include mq(ipadP) {
      padding: 20px 20px 20px $unit-vw * 2;
    }
  }

  &__title {
    font-size: 25px;
    margin: 0;
  }

  &:hover .card__container {
    transform: translateX(-8px) translateY(-8px);

    &::before {
      transform: translateX(8px) translateY(8px);
    }
  }
}

.card .card__description ::v-deep p {
  margin: 0;
  line-height: 1.2;
  color: var(--color-headline-dark);

  @at-root [data-city="toronto"] & {
    color: var(--color-cursor);
  }
}
</style>
